import { useQuery } from '@tanstack/react-query';
import { getClaimCorrectionNote } from '@uplift/api';
import { BaseQueryOpts } from '@uplift/queries';


export const useClaimCorrectionNote = (noteId: string, opts?: BaseQueryOpts) => {
  return useQuery([ 'claim-correction' ], async () => {
    const claimCorrectionResponse = await getClaimCorrectionNote(noteId);

    return claimCorrectionResponse.data;
  }, { ...opts });
};
